import React from 'react';

interface NoResultsProps {
  /** Messaggio principale */
  title?: string;
  /** Messaggio di dettaglio con suggerimenti */
  message?: string;
  /** Icona da mostrare */
  icon?: string;
  /** Funzione di callback per azione (es. resetta filtri) */
  onAction?: () => void;
  /** Testo del pulsante di azione */
  actionText?: string;
  /** Classe CSS personalizzata */
  className?: string;
  /** Suggerimenti per l'utente */
  suggestions?: string[];
}

/**
 * Componente NoResults riutilizzabile
 * Mostra un messaggio standardizzato quando non ci sono risultati
 */
export const NoResults: React.FC<NoResultsProps> = ({
  title = 'Nessun risultato trovato',
  message = 'Prova a modificare i criteri di ricerca.',
  icon = '🔍',
  onAction,
  actionText = 'Resetta filtri',
  className = '',
  suggestions = []
}) => {
  return (
    <div className={`no-results ${className}`} role="status" aria-live="polite">
      <div className="no-results-content">
        <div className="no-results-icon" aria-hidden="true">
          {icon}
        </div>
        
        <div className="no-results-text">
          <h3 className="no-results-title">{title}</h3>
          <p className="no-results-message">{message}</p>
          
          {suggestions.length > 0 && (
            <div className="no-results-suggestions">
              <p className="suggestions-title">Suggerimenti:</p>
              <ul className="suggestions-list">
                {suggestions.map((suggestion, index) => (
                  <li key={index} className="suggestion-item">
                    {suggestion}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        
        {onAction && (
          <div className="no-results-actions">
            <button 
              className="btn-secondary"
              onClick={onAction}
              type="button"
            >
              {actionText}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NoResults;